import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueApexCharts from "vue-apexcharts";
import VueAnalytics from "vue-analytics";
import VueIntercom from "vue-intercom";
import VueApollo from "vue-apollo";
import VueExcelXlsx from "vue-excel-xlsx";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import client from "@/apollo";
import "@/filters";
import { Auth0Plugin } from "@/auth";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/i18n";
// import { domain, clientId, audience } from "../auth_config.json";

const domain = process.env.VUE_APP_AUTH0_DOMAIN;
const clientId = process.env.VUE_APP_AUTH0_CLIENTID;
const audience = process.env.VUE_APP_AUDIENCE;

Vue.config.productionTip = false;
const isProd = process.env.NODE_ENV === "production";
Vue.use(VueAxios, axios);
Vue.use(VueAnalytics, {
  id: "UA-68575253-4",
  router,
  autoTracking: {
    exception: true,
  },
  debug: {
    enabled: !isProd,
    sendHitTask: isProd,
  },
});
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
  },
});
Vue.use(VueApexCharts);
Vue.use(VueIntercom, { appId: "f96n507j" });
Vue.use(VueApollo);
Vue.use(VueExcelXlsx);
Vue.component("apexchart", VueApexCharts);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  apolloProvider: new VueApollo({
    defaultClient: client,
  }),
  render: h => h(App),
}).$mount("#app");
